<template>
    <v-container>
        <template v-if="isAuthorized">
            <v-row no-gutters v-if="displayImportMap">
                <v-col cols="12">
                    <v-row no-gutters v-if="!$vuetify.display.mobile" class="my-3">
                        <v-col cols="2">
                            <v-btn-primary
                                block
                                @click="
                                    $router.push({
                                        name: 'importFec',
                                        params: {
                                            companyId: selectedCompany.id,
                                            mode: 'all',
                                            documentType: 'FEC',
                                        },
                                    })
                                "
                                v-if="currentUser.profile.configuration.accounting.write"
                                >Importer</v-btn-primary
                            >
                        </v-col>
                        <v-col cols="2" class="pl-2">
                            <v-btn-primary
                                block
                                v-if="
                                    currentUser.profile.configuration.accounting.write &&
                                    (!selectedCompany.profile ||
                                        selectedCompany.profile.createPaySlip)
                                "
                                @click="
                                    $router.push({
                                        name: 'importFec',
                                        params: {
                                            companyId: selectedCompany.id,
                                            mode: 'payslip',
                                            documentType: 'FEC',
                                        },
                                    })
                                "
                            >
                                Import Silae
                            </v-btn-primary>
                        </v-col>
                        <v-col cols="2" class="pl-2">
                            <v-btn-primary block @click="displayImportMapping()">
                                Import Mapping
                            </v-btn-primary>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col cols="12">
                    <!-- {{ paginationImport.page }} - {{ paginationImport.sortBy }} - {{ sortBy }} -->
                    <v-data-table-server
                        :headers="headersImport"
                        :items="accountingItemImports"
                        v-model:page="paginationImport.page"
                        v-model:sort-by="sortBy"
                        v-model:items-per-page="paginationImport.rowsPerPage"
                        :items-per-page-options="[5, 10, 25]"
                        :items-length="paginationImport.totalItems"
                        class="table"
                        fixed-header
                        max-height="60vh"
                    >
                        <template v-slot:item="props">
                            <tr
                                :style="
                                    isRunningImportButFailed(props.item)
                                        ? 'color:red;cursor: pointer'
                                        : 'cursor: pointer'
                                "
                            >
                                <td>
                                    {{ props.item.name }}
                                    <v-icon
                                        v-if="props.item.type === 'CONNECTOR'"
                                        size="x-small"
                                        rounded="circle"
                                        right
                                        color="secondary"
                                        >$fa-plug</v-icon
                                    >
                                </td>
                                <td @click.stop="openErrorDialog(props.item)">
                                    <span
                                        :style="
                                            props.item.status === 'IMPORTED_WITH_ERRORS'
                                                ? 'color:red'
                                                : ''
                                        "
                                        >{{
                                            $t(`accountingItemImport.status.${props.item.status}`)
                                        }}</span
                                    >
                                    <v-progress-linear
                                        color="secondary"
                                        height="10"
                                        buffer-value="0"
                                        v-if="
                                            props.item.status.startsWith('RUNNING') &&
                                            props.item.stepCount
                                        "
                                        stream
                                        :model-value="
                                            (100 * props.item.step) / props.item.stepCount
                                        "
                                    />
                                </td>
                                <td v-if="getAccountingPeriodTitle(props.item)">
                                    {{ getAccountingPeriodTitle(props.item) }}
                                </td>
                                <td style="text-align: center" class="px-0 text-center" v-else>
                                    <v-icon color="secondary" size="large">$dot</v-icon>
                                </td>
                                <td>
                                    {{ formatDateAndTime(props.item) }}
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        variant="text"
                                        :disabled="lockImport(props.item)"
                                        color="secondary"
                                        @click.stop="
                                            toDeleteAccountingItemImportId = props.item.id;
                                            deleteAccountingItemImportLoading = false;
                                            editAccountingItemImportDialog = true;
                                        "
                                        v-if="
                                            props.item.status.startsWith('IMPORTED') ||
                                            isRunningImportButFailed(props.item)
                                        "
                                        size="small"
                                        icon="$fa-eraser"
                                    >
                                    </v-btn>
                                    <v-btn
                                        variant="text"
                                        color="secondary"
                                        @click.stop="edit(props.item, undefined)"
                                        :disabled="props.item.type === 'CONNECTOR'"
                                    >
                                        <v-icon size="small">{{
                                            props.item.status.startsWith("EDITION")
                                                ? "$edit"
                                                : "$fa-eye"
                                        }}</v-icon>
                                    </v-btn>
                                    <!-- <v-btn
                                        text
                                        color="secondary"
                                        @click.stop="edit(props.item, 1)"
                                        v-if="props.item.status.startsWith('IMPORTED')"
                                    >
                                    <v-icon  size="small">$fa-hammer</v-icon>
                                    </v-btn> -->
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        variant="text"
                                        color="secondary"
                                        :disabled="
                                            isRunningImportButFailed(props.item) ||
                                            lockImport(props.item)
                                        "
                                        @click.stop="
                                            toDeleteAccountingItemImportId = props.item.id;
                                            deleteAccountingItemImportLoading = false;
                                            deleteAccountingItemImportDialog = true;
                                        "
                                        size="small"
                                        icon="$delete"
                                    >
                                    </v-btn>
                                </td>
                                <td class="text-center" @click.stop="download(props.item)">
                                    <v-btn
                                        variant="text"
                                        color="secondary"
                                        :disabled="!props.item.file"
                                        size="small"
                                        icon="$fa-cloud-download-alt"
                                    >
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table-server>
                </v-col>
            </v-row>
            <v-row no-gutters v-else class="my-3">
                <v-col>
                    <ImportMapping @closeImportMapping="closeImportMap()"> </ImportMapping>
                </v-col>
            </v-row>
            <oss-dialog
                v-model="deleteAccountingItemImportDialog"
                title="Supprimer"
                :error="true"
                @valid="deleteEditAccountingItemImport(true)"
                :validLoading="deleteAccountingItemImportLoading"
                width="800px"
            >
                <h4 class="text-center">
                    &#xca;tes-vous sûr(e) de vouloir supprimer ces données importées ?
                </h4>
            </oss-dialog>
            <oss-dialog
                v-model="editAccountingItemImportDialog"
                title="Réediter"
                @valid="deleteEditAccountingItemImport(false)"
                :validLoading="deleteAccountingItemImportLoading"
                width="800px"
            >
                <div class="text-center">
                    <h4>&#xca;tes-vous sûr(e) de vouloir rééditer les données importées ?</h4>
                    <div>Attention : les données importées seront supprimées</div>
                </div>
            </oss-dialog>
            <oss-dialog
                v-model="errorDialog"
                title="Detail sur les erreurs de l'import"
                width="800px"
            >
                <div class="text-center">
                    <div>{{ selectedImport ? selectedImport.errors : "XXX" }}</div>
                </div>
            </oss-dialog>
        </template>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import moment from "moment-timezone";
import { User } from "../store/store";

import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";
import { getLastAccountingClosingEndDateFromStore } from "../services/accountingPeriods";

import ACCOUNTING_ITEM_IMPORTS from "../graphql/accountingItem/AccountingItemImports.gql";
import DELETE_EDIT_ACCOUNTING_ITEM_IMPORT from "../graphql/accountingItem/DeleteEditAccountingItemImport.gql";
import getEnv from "../env";
import { NotificationBase } from "./NotificationBase";
import ImportMapping from "./ImportMapping.vue";
import { checkAccessRights } from "@/services/accessRightServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

const env = getEnv();

@Component({
    components: {
        ImportMapping,
    },
})
export class AccountingItems extends NotificationBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;

    // headers: Array<any> = [
    //     { text: "Type", value: 'type', align: 'left', sortable: true },
    //     { text: "Libellé", value: 'wording', align: 'left', sortable: true },
    //     { text: "Date", value: 'date', align: 'left', sortable: true },
    //     { text: "Crédit", value: '', align: 'left', sortable: true },
    //     { text: "Débit", value: '', align: 'left', sortable: true },
    //     { text: "Supprimer", value: '', align: 'center', sortable: false }
    // ]

    headersImport: Array<any> = [
        { title: "Nom", value: "type", align: "left", sortable: true },
        { title: "Statut", value: "status", align: "left", sortable: true },
        { title: "Exercice | Période", value: "accountingPeriod", align: "left", sortable: false },
        { title: "Dernière modification", value: "updatedAt", align: "left", sortable: true },
        { title: "Editer", value: "", align: "center", sortable: false },
        { title: "Supprimer", value: "", align: "center", sortable: false },
        { title: "Télécharger", value: "", align: "center", sortable: false },
    ];

    paginationImport: any = {
        page: 1,
        rowsPerPage: 10,
        sortBy: "updatedAt",
        descending: false,
        totalItems: 100,
    };

    get sortBy(): { key: string; order: "asc" | "desc" | boolean }[] {
        return [
            {
                key: this.paginationImport.sortBy,
                order: this.paginationImport.descending ? "desc" : "asc",
            },
        ];
    }

    set sortBy(newVal: { key: string; order: "asc" | "desc" | boolean }[]) {
        if (newVal.length === 0) {
            return;
        }
        const val = newVal[0];
        this.paginationImport.sortBy = val.key;
        this.paginationImport.descending = val.order === "desc" || val.order === true;
    }

    accountingItemType: string = "ALL";

    errorDialog: boolean = false;
    selectedImport = null;

    openErrorDialog(item) {
        if (item.errors) {
            this.selectedImport = item;
            this.errorDialog = true;
        } else {
            this.errorDialog = false;
        }
    }

    types = [
        { name: "Tous", type_name: "ALL" },
        { name: "Facture d'achat", type_name: "PURCHASE_INVOICE" },
        { name: "Facture de vente", type_name: "SALES_INVOICE" },
        { name: "Compte courant", type_name: "CURRENT_ACCOUNT" },
        { name: "Compte d'exploitant", type_name: "OPERATOR_ACCOUNT" },
        { name: "Facture de vente", type_name: "SALES_INVOICE" },
        { name: "Note de frais", type_name: "EXPENSE_REPORT" },
        { name: "Z de caisse", type_name: "ZTILL_RECEIPT" },
        { name: "OD de paie", type_name: "PAY_SLIP" },
        { name: "TVA", type_name: "VAT" },
        { name: "Divers", type_name: "MISCELLANEOUS_OPERATION" },
        { name: "Opérations diverses", type_name: "MISCELLANEOUS_OPERATION" },
        { name: "Reports à nouveau", type_name: "CARRY_FORWARD" },
    ];

    deleteAccountingItemImportDialog: boolean = false;
    deleteAccountingItemImportLoading: boolean = false;
    toDeleteAccountingItemImportId = "";

    editAccountingItemImportDialog: boolean = false;

    displayImportMap: boolean = true;

    displayImportMapping() {
        this.displayImportMap = false;
    }

    closeImportMap() {
        this.displayImportMap = true;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "import");
        return authorized;
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    getDateFormated(item) {
        return moment(item.date).format("DD/MM/YYYY");
    }

    formatDateAndTime(item) {
        const date = item.updatedAt || item.createdAt;
        if (!date) return "";
        moment.locale("fr");
        // return moment(item.updatedAt || item.createdAt).format("DD/MM/YYYY")
        return moment(date).local().format("DD/MM/YYYY - HH:mm");
    }

    newCommonFormatCurrency(value) {
        return newCommonFormatCurrency(value, undefined);
    }

    getAccountingPeriodTitle(item) {
        // debugger
        if (item.accountingPeriod) {
            return (
                "Exercice du " +
                moment(item.accountingPeriod.start).format("DD/MM/YYYY") +
                " au " +
                moment(item.accountingPeriod.end).format("DD/MM/YYYY")
            );
        }
        if (item.startDate && item.endDate) {
            return (
                "Période du " +
                moment(item.startDate).format("DD/MM/YYYY") +
                " au " +
                moment(item.endDate).format("DD/MM/YYYY")
            );
        }
        return "";
    }

    @Apollo({
        query: ACCOUNTING_ITEM_IMPORTS,
        variables() {
            return {
                companyId: this.selectedCompany.id,
                types: ["STANDARD", "SYLAE", "CONNECTOR"],
                first:
                    this.paginationImport.rowsPerPage > 0 ? this.paginationImport.rowsPerPage : 100,
                skip: this.paginationImport.rowsPerPage * (this.paginationImport.page - 1),
                orderBy: this.formatOrderByImport,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.isAuthorized || !this.selectedCompany;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    // debugger
                    if (data.accountingItemImports) {
                        this.accountingItemImports = data.accountingItemImports;
                    } else {
                        this.accountingItemImports = [];
                    }
                    if (
                        data.accountingItemImportsConnection &&
                        data.accountingItemImportsConnection.aggregate &&
                        data.accountingItemImportsConnection.aggregate.count !== null
                    ) {
                        this.paginationImport.totalItems =
                            data.accountingItemImportsConnection.aggregate.count;
                    } else {
                        this.paginationImport.totalItems = 0;
                    }
                }
            }
        },
    })
    accountingItemImports: any[] = [];

    beforeMount() {
        this.addListener("accountingItemImport");
    }

    beforeDestroy() {
        if (this.$apollo.queries && this.$apollo.queries.accountingItemImports) {
            this.$apollo.queries.accountingItemImports.stop();
        }
        this.removeListener();
    }

    onMessage(data) {
        console.log(data);
        if (data) {
            console.log("onMessage action", data.action);
            if (data.action === "create") {
                const accountingItemImport = this.accountingItemImports.find(
                    (aie) => aie.id === data.id,
                );
                if (!accountingItemImport) {
                    this.accountingItemImports.splice(0, 0, data.payload);
                }
            } else if (data.action === "update") {
                const accountingItemImport = this.accountingItemImports.find(
                    (aie) => aie.id === data.id,
                );
                if (accountingItemImport) {
                    accountingItemImport.status = data.payload.status;
                    accountingItemImport.step = data.payload.step;
                    accountingItemImport.stepCount = data.payload.stepCount;
                    accountingItemImport.createdAt = data.payload.createdAt;
                    accountingItemImport.updatedAt = data.payload.updatedAt;
                }
            } else if (data.action === "delete") {
                const index = this.accountingItemImports.findIndex((aie) => aie.id === data.id);
                if (index !== -1) {
                    this.accountingItemImports.splice(index, 1);
                }
            }
        }
    }

    //
    //
    //

    get formatOrderByImport() {
        // debugger
        const fieldName = this.paginationImport.sortBy || "updatedAt";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.paginationImport.descending ? "_DESC" : "_ASC";
        } else {
            direction = this.paginationImport.descending ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }

    openAccountingItem(id: string) {
        this.$router.push({
            name: "accountingItem",
            params: {
                companyId: this.selectedCompany.id,
                id: id,
            },
        });
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.accountingItemImports) {
            this.$apollo.queries.accountingItemImports.refetch();
        } else {
            debugger;
        }
    }

    async deleteEditAccountingItemImport(deleteAAI) {
        if (this.toDeleteAccountingItemImportId) {
            this.deleteAccountingItemImportLoading = true;
            await this.$apollo
                .mutate({
                    mutation: DELETE_EDIT_ACCOUNTING_ITEM_IMPORT,
                    variables: {
                        id: this.toDeleteAccountingItemImportId,
                        delete: deleteAAI,
                        status: "EDITION",
                    },
                })
                .catch((err) => {
                    console.error(
                        "AccountingItems.vue ~ DELETE_EDIT_ACCOUNTING_ITEM_IMPORT erroor : ",
                        err,
                    );
                });
            this.toDeleteAccountingItemImportId = "";
            this.deleteAccountingItemImportLoading = false;
            this.refresh();
        }
        this.deleteAccountingItemImportDialog = false;
        this.editAccountingItemImportDialog = false;
    }

    edit(accountingItemImport, repair) {
        this.$router.push({
            name: !repair ? "importFecEdition" : "importFecRepair",
            params: {
                companyId: this.selectedCompany.id,
                documentType: "FEC",
                id: accountingItemImport.id,
                repair: repair,
            },
        });
    }

    download(item) {
        window.open(`${env.VUE_APP_BACKEND}/accountingItemImport/download/${item.id}`, "_blank");
    }

    isRunningImportButFailed(item) {
        if (item.status.startsWith("RUNNING")) {
            // return true
            if (moment().diff(item.updatedAt, "minutes") > 5) {
                return true;
            }
        }
        return false;
    }

    lockImport(propsItem) {
        // return false
        if (propsItem.type === "CONNECTOR") {
            return true;
        }
        if (this.isRunningImportButFailed(propsItem)) {
            return false;
        }
        if (propsItem.status === "IMPORTED") {
            if (propsItem.accountingPeriod?.closed) {
                return true;
            }
            if (propsItem.endDate) {
                const lastClosingEndDate: any = getLastAccountingClosingEndDateFromStore(
                    this.$store,
                );

                if (lastClosingEndDate) {
                    const lastClosingDateYYYYMMDD = moment(lastClosingEndDate).format("YYYY-MM-DD");
                    const propsEndDateYYYYMMDD = moment(propsItem.endDate).format("YYYY-MM-DD");
                    if (moment(lastClosingDateYYYYMMDD).isSameOrAfter(propsEndDateYYYYMMDD)) {
                        return true;
                    }
                    const propsStartDateYYYYMMDD = moment(propsItem.startDate).format("YYYY-MM-DD");
                    if (moment(lastClosingDateYYYYMMDD).isSameOrAfter(propsStartDateYYYYMMDD)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
}

export default toNative(AccountingItems);
</script>
